import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const MuiTelInput = lazyImport(() =>
  import('mui-tel-input').then((module) => ({ default: module.MuiTelInput }))
)
